import axios from "axios";
import Swal from "sweetalert2";

export const getReviews = async (page ,filters ,productId, storeId) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const params = {
         page ,...filters 
      };
      
      // Add either product_id or store_id based on what's provided
      if (productId) {
        params.product_id = productId;
      }
      if (storeId) {
        params.store_id = storeId;
      }
      
      const { data } = await axios.get(
        `/v1/admin/reviews`,    
        {
          params,
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang:lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error
    }
  };

  export const deleteReviews = async (id,lang) => {
    const brear = localStorage.getItem("token");
    const result = await Swal.fire({
      title: "هل انت متأكد ؟",
      text: "سيتم الحذف",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Okay",
    });
    if (result.isConfirmed) {
      try {
        const { data } = await axios.delete(`v1/admin/reviews/${id}`, {
          headers:{
                  Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
          }
    
        });
        if (data.success === true) {
          Swal.fire("Deleted!", `${data.message}`, "success");
        } else {
          Swal.fire("Not deleted", `${data.message}`, "info");
        }
        return data;
      } catch (error) {
        throw error;
      }
    }
  };